import React from 'react';
import css from 'styled-jsx/css';
import Container from '~/components/Container';
import config from '~/config';
import themeVariables from '~/shared/themeVariables';

const MATERIALS = [
  {
    labelKey: 'illustrations',
    imageURL: `${config.staticPrefix}/static/images/sell-your-content-page/illustrations.jpg`,
  },
  {
    labelKey: 'silhouettes',
    imageURL: `${config.staticPrefix}/static/images/sell-your-content-page/silhouettes.jpg`,
  },
  {
    labelKey: 'templates',
    imageURL: `${config.staticPrefix}/static/images/sell-your-content-page/templates.jpg`,
  },
];

const DesktopView = ({ t }) => {
  return (
    <Container
      className={containerClassName}
      contentClassName={contentClassName}
    >
      <img
        className="img-wiggle lazyload"
        data-srcset={`${config.staticPrefix}/static/images/submission-guideline-page/mobile-view/wiggle-1.png`}
      />
      <h2 className="title">{t('what_upload_to_illustAC')}</h2>
      <div className="materials-list">
        {MATERIALS.map(({ labelKey, imageURL }, idx) => {
          return (
            <div key={labelKey} className="material-item">
              <div className="material-item-content">
                <div className="number">{idx + 1}</div>
                <div className="label">{t(labelKey)}</div>
                <img
                  className="img-material"
                  src={imageURL}
                  alt={t(labelKey)}
                />
              </div>
            </div>
          );
        })}
      </div>
      <style jsx>{styles}</style>
      {containerStyles}
      {contentStyles}
    </Container>
  );
};

const { className: containerClassName, styles: containerStyles } = css.resolve`
  width: 100%;
  margin-top: -111px;
  padding-top: 208px;
  background: #f8f9fa;

  @media (max-width: ${themeVariables.breakpoints.tabletS.maxWidth}px) {
    margin-top: 32px;
    padding-top: 0;
    padding-bottom: 32px;
  }
`;

const { className: contentClassName, styles: contentStyles } = css.resolve`
  display: flex;
  flex-direction: column;
`;

const styles = css`
  .img-wiggle {
    display: none;
  }

  .title {
    font-size: 40px;
    font-weight: 600;
    padding: 0;
    margin: 0;
  }

  .materials-list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 42px;
  }

  .material-item {
    width: 30%;
    background: #454285;
    height: 234px;
    color: #fff;
    padding: 16px;
  }

  .material-item-content {
    position: relative;
    width: 100%;
    height: 100%;
    font-weight: 600;
  }
  .number {
    position: absolute;
    top: -16px;
    left: 0;
    font-size: 40px;
  }
  .img-material {
    width: 140px;
    position: absolute;
    top: 0;
    right: 0;
  }
  .label {
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 24px;
  }

  @media (max-width: ${themeVariables.breakpoints.tabletS.maxWidth}px) {
    .img-wiggle {
      display: inherit;
      width: 100%;
      margin-top: 24px;
    }

    .title {
      font-size: 24px;
      margin-top: 32px;
    }

    .materials-list {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      margin-top: 24px;
    }

    .material-item {
      width: 100%;
      margin-bottom: 8px;
      height: 176px;
    }
  }
`;

export default DesktopView;
